const colors = {
  white: '#FFFFFF',
  black: '#000000',
  gray: 'rgba(0, 0, 0, .33)',
  lightGray: '#F0F0F0',
  darkGray: '#333333',
  lightBlue: '#F2F8FC',
  red: '#FFA0A0',
  lightRed: '#FFF6F6',
  darkRed: '#FF3838',
};

const defaultTheme = {
  colors: {
    ...colors,
    bg: colors.white,
    acc1: colors.black,
    acc2: colors.darkGray,
    text: colors.black,
    inputBorder: colors.black,
    inputBorderAcc: colors.gray,
  },
  fonts: {
    default: "'PF DIN Cond Pro', sans-serif",
    secondary: "'PF DIN Text Pro', sans-serif",
  },
  animation: {
    default: '.33s ease-in-out',
    fast: '.25s ease-out',
  },
};

export default {
  default: {
    name: 'default',
    ...defaultTheme,
  },
};
